import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, Badge, Th, Td, Empty, fmtDate } from "./ui";

export default function Payments() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/payments").then((r) => setRows(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageHeader title="Betalingen" subtitle="Alle betaaltransacties (Stripe, testmodus)" />
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-white/10"><tr><Th>Payment ID</Th><Th>Order</Th><Th>Bedrag</Th><Th>Status</Th><Th>Vervalt</Th><Th>Aangemaakt</Th></tr></thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.id} className="border-b border-white/5">
                  <Td className="max-w-[180px] truncate font-mono text-xs text-white/50">{p.provider_payment_id}</Td>
                  <Td className="text-sfc-orange">{p.order_id?.slice(0, 8)}</Td>
                  <Td>€{p.amount.toFixed(2)}</Td>
                  <Td><Badge status={p.status} /></Td>
                  <Td className="text-white/50">{fmtDate(p.expires_at)}</Td>
                  <Td className="text-white/50">{fmtDate(p.created_at)}</Td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <Empty text="Nog geen betalingen" />}
        </div>
      </Card>
    </div>
  );
}
